// Static data for theming
export default [
  {
    name: "Spring",
    color: "#8e44ad"
  },
  {
    name: "Summer",
    color: "#00ff00"
  },
  {
    name: "Autumn",
    color: "#c0392b"
  },
  {
    name: "Winter",
    color: "#3498db"
  }
];



// WEBPACK FOOTER //
// ./src/seasons.js